module.exports = __webpack_public_path__ + "img/qiyename.ac36a33c.png";